import { Button } from "../ui/button";
import { glassCard } from "../../utils/glassStyles";

export default function RecruiterEmptyState({ icon: Icon, title, description, actionLabel, onAction }) {
  return (
    <div className={`rounded-2xl border-2 border-dashed border-white/20 dark:border-white/10 py-16 px-6 text-center ${glassCard}`}>
      {Icon && (
        <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-primary/10 flex items-center justify-center">
          <Icon className="w-8 h-8 text-primary/70" />
        </div>
      )}
      <h3 className="text-lg font-semibold mb-2">{title}</h3>
      <p className="text-sm text-muted-foreground mb-6 max-w-sm mx-auto">{description}</p>
      {actionLabel && onAction && (
        <Button onClick={onAction} size="lg">
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
